import { doc } from "firebase/firestore";
import { firestore } from "../firebase";
import { countriesPath } from "./countriesPath";

const getAllCountriesRef = () => {
  return doc(firestore, countriesPath.countries);
};

export default getAllCountriesRef;
